import React from 'react';
import Component from '../components/Component';
import Container from '../components/Container';
import AppGallery from '../components/AppGallery';
import GameGallery from '../components/GameGallery';
import brain from '../assets/images/brain.svg';

class Home extends Component {
  render() {
    return (
      <Container page="Home" margin={false}>
        <div className="body big-margin">
          <img src={brain} className="big-logo" alt="Cerebral Cereal logo" />
          <div className="title  no-select">Cerebral Cereal</div>
          <div className="tagline  no-select mb2">Creating free apps for all with no strings attached.</div>
        </div>
        <div className="h1 m2 mrauto">Android Apps</div>
        <AppGallery mode="store" />
        <GameGallery />
      </Container>
    );
  }
}

export default Home;
